import { FREIGHT_TYPE_MESSAGES, FreightTypeMessages } from "../freight/freight-type.messages";

export type ConfigurationTabMessages = FreightTypeMessages & {
  configurationTabTitle: string;
  freightTypeLabel: string;
  unitDeliveryTimeLabel: string;
  unitDeliveryTimeHint: string;
  errorUnitDeliveryTimeMaxLength: string;
  freightOverheadLabel: string;
  freightOverheadTypeLabel: string;
  freightOverheadTypeMonetary: string;
  freightOverheadTypePercentage: string;
  errorFreightOverheadInvalid: string;
  freightDescriptionTitle: string;
  noDescriptionAvailable: string;
  freightSection: string;
  noLogisticsPlatformActiveHint: string;
  logisticsPlatformLoadErrorHint: string;

  updateCustomerConfigurationSuccess: string;
  updateCustomeConfigurationrError: string;

  createCustomerConfigurationSuccess: string;
  createCustomeConfigurationrError: string;

  errorRequiredFreightType: string;

  daysUntilDueSection: string;
  daysUntilDueLabel: string;
  paymentReminderIntervalLabel: string;
  paymentReminderTimesLabel: string;
  paymentReminderIntervalHint: string;
  paymentReminderTimesHint: string;
  errorRequiredDaysUntilDue: string;
  errorDaysUntilDuePositive: string;
  errorDaysUntilDueInteger: string;
  errorPaymentReminderPositive: string;
  errorPaymentReminderInteger: string;

  noConfigurationFoundToast: string;
  noConfigurationFoundTitle: string;
  noConfigurationFoundDescription: string;
  loadConfigurationErrorTitle: string;
  loadConfigurationErrorDescription: string;

  freightModalTextNonUse: string;
  freightModalTextOwn: string;
  freightModalTextAutomated: string;

  freightOverheadDocTitle: string;
  freightOverheadDocNeedTitle: string;
  freightOverheadDocNeedText: string;
  freightOverheadDocBehaviorTitle: string;
  freightOverheadDocBehaviorMonetary: string;
  freightOverheadDocBehaviorPercentage: string;
  freightOverheadDocExceptionsTitle: string;
  freightOverheadDocExceptionZeroFreight: string;
  freightOverheadDocExceptionNoValue: string;
  freightOverheadDocExceptionFreeShipping: string;
  freightOverheadDocExampleTitle: string;
  freightOverheadDocExampleMonetary: string;
  freightOverheadDocExamplePercentage: string;
  freightOverheadDocExampleZero: string;
  freightOverheadDocNote: string;

  consentSection: string;
  consentRequestLabel: string;
  consentExpirationLabel: string;
  cancelOptionLabel: string;

  consentExpirationThreeMonths: string;
  consentExpirationSixMonths: string;
  consentExpirationTwelveMonths: string;
  consentExpirationTwentyFourMonths: string;

  cancelOptionActivated: string;
  cancelOptionDeactivated: string;

  serviceHoursSection: string;
  serviceHoursWeekDayColumn: string;
  serviceHoursStartHourColumn: string;
  serviceHoursEndHourColumn: string;
  serviceHoursDescriptionColumn: string;
  serviceHoursOptionsColumn: string;
  serviceHoursNewButton: string;
  serviceHoursWeekDayLabel: string;
  serviceHoursStartHourLabel: string;
  serviceHoursEndHourLabel: string;
  serviceHoursDescriptionLabel: string;
  serviceHoursCreateSuccess: string;
  serviceHoursCreateError: string;
  serviceHoursUpdateSuccess: string;
  serviceHoursUpdateError: string;
  serviceHoursDeleteSuccess: string;
  serviceHoursDeleteError: string;
  serviceHoursLoadErrorTitle: string;
  serviceHoursLoadErrorDescription: string;
  serviceHoursEmptyMessage: string;
  serviceHoursEditPopover: string;
  serviceHoursDeletePopover: string;
  serviceHoursDeleteDialogTitle: string;
  serviceHoursDeleteDialogContent: string;
  serviceHoursFormCreateTitle: string;
  serviceHoursFormEditTitle: string;
  serviceHoursSaveButton: string;
  serviceHoursCancelButton: string;
  errorRequiredWeekDay: string;
  errorRequiredStartHour: string;
  errorRequiredEndHour: string;
  errorRequiredDescription: string;
  errorEndHourAfterStart: string;
  serviceHoursBulkFormTitle: string;
  serviceHoursBulkWeekDaysTitle: string;
  serviceHoursBulkWeekDaysDescription: string;
  serviceHoursBulkHoursTitle: string;
  serviceHoursBulkHoursDescription: string;
  serviceHoursBulkSelectBusinessDays: string;
  serviceHoursBulkSelectAllDays: string;
  serviceHoursBulkClearSelection: string;
  serviceHoursBulkCreateSuccess: string;
  serviceHoursBulkCreateError: string;
  serviceHoursBulkSetupButton: string;
  errorRequiredBulkWeekDays: string;

  closedDaysSection: string;
  closedDaysDateColumn: string;
  closedDaysDescriptionColumn: string;
  closedDaysOptionsColumn: string;
  closedDaysNewButton: string;
  closedDaysDateLabel: string;
  closedDaysDescriptionLabel: string;
  closedDaysCreateSuccess: string;
  closedDaysCreateError: string;
  closedDaysUpdateSuccess: string;
  closedDaysUpdateError: string;
  closedDaysDeleteSuccess: string;
  closedDaysDeleteError: string;
  closedDaysLoadErrorTitle: string;
  closedDaysLoadErrorDescription: string;
  closedDaysEmptyMessage: string;
  closedDaysEditPopover: string;
  closedDaysDeletePopover: string;
  closedDaysDeleteDialogTitle: string;
  closedDaysDeleteDialogContent: string;
  closedDaysFormCreateTitle: string;
  closedDaysFormEditTitle: string;
  closedDaysSaveButton: string;
  closedDaysCancelButton: string;
  errorRequiredClosedDay: string;
  errorRequiredClosedDayDescription: string;

  weekDayMonday: string;
  weekDayTuesday: string;
  weekDayWednesday: string;
  weekDayThursday: string;
  weekDayFriday: string;
  weekDaySaturday: string;
  weekDaySunday: string;

  rowsPerPage: string;
  optionsColumn: string;
};

export const CONFIGURATION_TAB_MESSAGES: ConfigurationTabMessages = {
  configurationTabTitle: "Configuração",
  freightSection: "Configuração de Regiões de abrangência e fretes",
  noLogisticsPlatformActiveHint: "Nenhuma plataforma de logística ativada",
  logisticsPlatformLoadErrorHint: "Não foi possível carregar a plataforma de logística",
  freightTypeLabel: "Controle de áreas de abrangência e fretes",
  unitDeliveryTimeLabel: "Unidade de medida do prazo de entrega",
  unitDeliveryTimeHint: "Unidade utilizada nos prazos de entrega (padrão: Dias úteis)",
  errorUnitDeliveryTimeMaxLength: "A unidade deve ter no máximo 15 caracteres",
  freightOverheadLabel: "Sobretaxa sobre o valor do frete",
  freightOverheadTypeLabel: "Tipo do valor de sobretaxa",
  freightOverheadTypeMonetary: "Valor monetário",
  freightOverheadTypePercentage: "Porcentagem",
  errorFreightOverheadInvalid: "Informe uma sobretaxa válida",
  freightDescriptionTitle: "Controle de áreas de abrangência e fretes",
  noDescriptionAvailable: "Nenhuma descrição disponível",

  updateCustomerConfigurationSuccess: "Configuração atualizada com sucesso",
  updateCustomeConfigurationrError: "Erro ao atualizar configuração",
  createCustomeConfigurationrError: "Erro ao criar configuração",
  createCustomerConfigurationSuccess: "Configuração criada com sucesso",

  errorRequiredFreightType: "O controle de áreas de abrangência e fretes é obrigatório",

  daysUntilDueSection: "Vencimento e lembretes",
  daysUntilDueLabel: "Dias até o vencimento da parcela",
  paymentReminderIntervalLabel: "Tempo para envio de lembrete de pagamento (min)",
  paymentReminderTimesLabel: "Número de envio de lembrete",
  paymentReminderIntervalHint: "Tempo entre cada lembrete em minutos (padrão: 2)",
  paymentReminderTimesHint: "Número máximo de envios de lembrete (padrão: 2)",
  errorRequiredDaysUntilDue: "Este campo é obrigatório",
  errorDaysUntilDuePositive: "O número de dias deve ser no mínimo 1.",
  errorDaysUntilDueInteger: "Informe um número inteiro de dias para o vencimento do pagamento.",
  errorPaymentReminderPositive: "O valor deve ser no mínimo 1.",
  errorPaymentReminderInteger: "Informe um número inteiro.",

  noConfigurationFoundToast: "Nenhuma configuração encontrada. Tente novamente mais tarde.",
  noConfigurationFoundTitle: "Nenhuma configuração encontrada",
  noConfigurationFoundDescription: "Não encontramos nenhuma configuração para esta empresa.",
  loadConfigurationErrorTitle: "Erro ao carregar configuração",
  loadConfigurationErrorDescription:
    "Erro ao carregar as configurações. Tente novamente mais tarde.",

  freightModalTextNonUse:
    "Não utilizar: não verifica a área de atendimento, nem realiza o cálculo do frete.",
  freightModalTextOwn:
    "Utilizar com tabela de frete própria: verifica se o CEP do cliente está cadastrado na área de abrangência, informando se atende ou não a região e permite realizar o cálculo de frete conforme tabela de regiões cadastrada.",
  freightModalTextAutomated:
    "Utilizar com tabela de frete automatizada: verifica se o CEP do cliente é atendimento para entrega e realiza o cálculo de frete mediante a integração de um operador logístico ativado em plataformas.",

  freightOverheadDocTitle: "Sobretaxa sobre o valor do frete",
  freightOverheadDocNeedTitle: "Necessidade",
  freightOverheadDocNeedText:
    "É comum nas operações de e-commerce os lojistas adicionarem um % ou valor fixo ao total do frete calculado. Isso garante uma segurança e protege a margem de lucro contra erros de pesos, redespachos, taxas extras da transportadora, entre outros imprevistos.",
  freightOverheadDocBehaviorTitle: "Como funciona",
  freightOverheadDocBehaviorMonetary:
    "Valor monetário: o valor informado (em R$) é somado ao frete calculado. Frete final = frete original + sobretaxa.",
  freightOverheadDocBehaviorPercentage:
    "Porcentagem: o percentual informado incide sobre o frete calculado. Frete final = frete original + (frete original x %).",
  freightOverheadDocExceptionsTitle: "Exceções",
  freightOverheadDocExceptionZeroFreight:
    "IMPORTANTE: se o frete original for igual a 0, a sobretaxa nunca é aplicada. O cliente continua vendo frete R$ 0,00.",
  freightOverheadDocExceptionNoValue:
    "Sobretaxa em branco ou igual a 0: nada é somado, o frete é exibido exatamente como calculado.",
  freightOverheadDocExceptionFreeShipping:
    "Frete gratuito por regra da área de abrangência (pedido acima do valor configurado): a sobretaxa também não é aplicada, pois o frete original passa a ser 0.",
  freightOverheadDocExampleTitle: "Exemplos",
  freightOverheadDocExampleMonetary:
    "Sobretaxa configurada de R$ 5,00 (valor monetário) e frete da área de abrangência de R$ 20,00: o cliente vê R$ 25,00 na compra.",
  freightOverheadDocExamplePercentage:
    "Sobretaxa configurada de 10% (porcentagem) e frete da área de abrangência de R$ 20,00: o cliente vê R$ 22,00 na compra.",
  freightOverheadDocExampleZero:
    "Sobretaxa configurada de 10% e frete da área de abrangência de R$ 0,00: o cliente vê R$ 0,00 na compra (a sobretaxa não é aplicada).",
  freightOverheadDocNote:
    "A sobretaxa é aplicada sempre sobre o total do frete calculado, após a definição da faixa de CEP e peso na área de abrangência, e antes da exibição do valor ao cliente na conversa.",

  consentSection: "Consentimento de Coleta de Dados",
  consentRequestLabel: "Solicitação de Consentimento de Coleta de Dados",
  consentExpirationLabel: "Tempo de Expiração do Consentimento",
  cancelOptionLabel: "Opção de cancelamento",

  consentExpirationThreeMonths: "3 meses",
  consentExpirationSixMonths: "6 meses",
  consentExpirationTwelveMonths: "12 meses",
  consentExpirationTwentyFourMonths: "24 meses",

  cancelOptionActivated: "Ativado",
  cancelOptionDeactivated: "Desativado",

  serviceHoursSection: "Horário de funcionamento",
  serviceHoursWeekDayColumn: "Dia da semana",
  serviceHoursStartHourColumn: "Hora inicial",
  serviceHoursEndHourColumn: "Hora final",
  serviceHoursDescriptionColumn: "Descrição",
  serviceHoursOptionsColumn: "Opções",
  serviceHoursNewButton: "NOVO",
  serviceHoursWeekDayLabel: "Dia da semana",
  serviceHoursStartHourLabel: "Hora inicial",
  serviceHoursEndHourLabel: "Hora final",
  serviceHoursDescriptionLabel: "Descrição",
  serviceHoursCreateSuccess: "Horário cadastrado com sucesso",
  serviceHoursCreateError: "Erro ao cadastrar horário",
  serviceHoursUpdateSuccess: "Horário atualizado com sucesso",
  serviceHoursUpdateError: "Erro ao atualizar horário",
  serviceHoursDeleteSuccess: "Horário excluído com sucesso",
  serviceHoursDeleteError: "Erro ao excluir horário",
  serviceHoursLoadErrorTitle: "Erro ao carregar horários",
  serviceHoursLoadErrorDescription: "Não foi possível carregar os horários de funcionamento.",
  serviceHoursEmptyMessage: "Nenhum horário cadastrado",
  serviceHoursEditPopover: "Editar",
  serviceHoursDeletePopover: "Excluir",
  serviceHoursDeleteDialogTitle: "Excluir horário",
  serviceHoursDeleteDialogContent: "Deseja realmente excluir este horário de funcionamento?",
  serviceHoursFormCreateTitle: "Novo horário de funcionamento",
  serviceHoursFormEditTitle: "Editar horário de funcionamento",
  serviceHoursSaveButton: "Salvar",
  serviceHoursCancelButton: "Cancelar",
  errorRequiredWeekDay: "Selecione o dia da semana",
  errorRequiredStartHour: "Informe a hora inicial",
  errorRequiredEndHour: "Informe a hora final",
  errorRequiredDescription: "Informe a descrição",
  errorEndHourAfterStart: "A hora final deve ser maior que a hora inicial",
  serviceHoursBulkFormTitle: "Configurar horário de funcionamento",
  serviceHoursBulkWeekDaysTitle: "Dias da semana",
  serviceHoursBulkWeekDaysDescription: "Selecione os dias em que a empresa atende",
  serviceHoursBulkHoursTitle: "Horário",
  serviceHoursBulkHoursDescription: "O mesmo horário será aplicado a todos os dias selecionados",
  serviceHoursBulkSelectBusinessDays: "Dias úteis",
  serviceHoursBulkSelectAllDays: "Todos os dias",
  serviceHoursBulkClearSelection: "Limpar",
  serviceHoursBulkCreateSuccess: "Horários cadastrados com sucesso",
  serviceHoursBulkCreateError: "Erro ao cadastrar horários",
  serviceHoursBulkSetupButton: "CONFIGURAR HORÁRIOS",
  errorRequiredBulkWeekDays: "Selecione pelo menos um dia da semana",

  closedDaysSection: "Feriados",
  closedDaysDateColumn: "Data",
  closedDaysDescriptionColumn: "Descrição",
  closedDaysOptionsColumn: "Opções",
  closedDaysNewButton: "NOVO",
  closedDaysDateLabel: "Data",
  closedDaysDescriptionLabel: "Descrição",
  closedDaysCreateSuccess: "Feriado cadastrado com sucesso",
  closedDaysCreateError: "Erro ao cadastrar feriado",
  closedDaysUpdateSuccess: "Feriado atualizado com sucesso",
  closedDaysUpdateError: "Erro ao atualizar feriado",
  closedDaysDeleteSuccess: "Feriado excluído com sucesso",
  closedDaysDeleteError: "Erro ao excluir feriado",
  closedDaysLoadErrorTitle: "Erro ao carregar feriados",
  closedDaysLoadErrorDescription: "Não foi possível carregar os feriados.",
  closedDaysEmptyMessage: "Nenhum feriado cadastrado",
  closedDaysEditPopover: "Editar",
  closedDaysDeletePopover: "Excluir",
  closedDaysDeleteDialogTitle: "Excluir feriado",
  closedDaysDeleteDialogContent: "Deseja realmente excluir este feriado?",
  closedDaysFormCreateTitle: "Novo feriado",
  closedDaysFormEditTitle: "Editar feriado",
  closedDaysSaveButton: "Salvar",
  closedDaysCancelButton: "Cancelar",
  errorRequiredClosedDay: "Informe a data",
  errorRequiredClosedDayDescription: "Informe a descrição",

  weekDayMonday: "Segunda-feira",
  weekDayTuesday: "Terça-feira",
  weekDayWednesday: "Quarta-feira",
  weekDayThursday: "Quinta-feira",
  weekDayFriday: "Sexta-feira",
  weekDaySaturday: "Sábado",
  weekDaySunday: "Domingo",

  rowsPerPage: "Linhas por página:",
  optionsColumn: "Opções",

  ...FREIGHT_TYPE_MESSAGES,
};
